/**
 * to enable views to be reused, is needed to update ROUTES of the routing module for the specific view to reuse.
 * this flag is {reuseRoute: true}
 * example route WITHOUT flag:
 *
 * const routes: Routes = [
 *   {
 *    path: '',
 *    component: IndexCandidatesComponent,
 *    canActivate: [AuthGuard],
 *    data: {
 *      title: 'Candidates'
 *    }
 *  }
 * ];
 *
 * example route WITH flag:
 *
 * const routes: Routes = [
 *   {
 *    path: '',
 *    component: IndexCandidatesComponent,
 *    canActivate: [AuthGuard],
 *    data: {
 *      title: 'Candidates',
 *      reuseRoute: true
 *    }
 *  }
 * ];
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var CustomRouteReuseStrategy = /** @class */ (function () {
    function CustomRouteReuseStrategy() {
        /**
         * map where are stored views to be reused
         */
        this.storedRoutes = {};
    }
    /**
     * method for scroll window
     */
    CustomRouteReuseStrategy.prototype.windowScroll = function (y) {
        window.scrollTo(0, y);
    };
    CustomRouteReuseStrategy.prototype.shouldDetach = function (route) {
        // if reuseRoute is true, we store in storedRoutes all we need to reuse this view with also scrollPosition
        if (route.data.reuseRoute) {
            var id = this.createIdentifier(route);
            var y = window.scrollY;
            var __handle = this._handle;
            var __snapshot = this._snapshot;
            this.storedRoutes[id] = { handle: __handle, snapshot: __snapshot, y: y };
        }
        return route.data.reuseRoute || false;
    };
    CustomRouteReuseStrategy.prototype.store = function (route, handle) {
        var id = this.createIdentifier(route);
        var y = window.scrollY;
        if (route.data.reuseRoute && id.length > 0) {
            this._handle = handle;
            this._snapshot = route;
            if (this.storedRoutes[id]) {
                this.storedRoutes[id].handle = handle;
                this.storedRoutes[id].snapshot = route;
            }
            else {
                this.storedRoutes[id] = { handle: handle, snapshot: route, y: y };
            }
        }
    };
    CustomRouteReuseStrategy.prototype.shouldAttach = function (route) {
        var _this = this;
        var id = this.createIdentifier(route);
        var storedObject = this.storedRoutes[id];
        var canAttach = !!route.routeConfig && !!storedObject;
        if (!canAttach) {
            return false;
        }
        var paramsMatch = this.compareObjects(route.params, storedObject.snapshot.params);
        var queryParamsMatch = this.compareObjects(route.queryParams, storedObject.snapshot.queryParams);
        /*
          uncomment below code for local debuging
        */
        // console.log('deciding to attach...', route, 'does it match?');
        // console.log('param comparison:', paramsMatch);
        // console.log('query param comparison', queryParamsMatch);
        // console.log(storedObject.snapshot, 'return: ', paramsMatch && queryParamsMatch);
        setTimeout(function () {
            _this.windowScroll(_this.storedRoutes[id].y || 0);
        }, 250);
        return paramsMatch && queryParamsMatch;
    };
    CustomRouteReuseStrategy.prototype.retrieve = function (route) {
        var id = this.createIdentifier(route);
        if (!route.routeConfig || !this.storedRoutes[id]) {
            return null;
        }
        return this.storedRoutes[id].handle;
    };
    CustomRouteReuseStrategy.prototype.shouldReuseRoute = function (future, curr) {
        return future.routeConfig === curr.routeConfig;
    };
    /*
     * method used to create a unique identifier
     */
    CustomRouteReuseStrategy.prototype.createIdentifier = function (route) {
        var _a;
        // Build the complete path from the root to the input route
        var segments = route.pathFromRoot.map(function (r) { return r.url; });
        var subpaths = (_a = []).concat.apply(_a, segments).map(function (segment) { return segment.path; });
        // Result: ${route_depth}-${path}
        return segments.length + '-' + subpaths.join('/');
    };
    CustomRouteReuseStrategy.prototype.compareObjects = function (base, compare) {
        // loop through all properties
        for (var baseProperty in __assign({}, base, compare)) {
            // determine if comparrison object has that property, if not: return false
            if (compare.hasOwnProperty(baseProperty)) {
                switch (typeof base[baseProperty]) {
                    // if one is object and other is not: return false
                    // if they are both objects, recursively call this comparison function
                    case 'object':
                        if (typeof compare[baseProperty] !== 'object' || !this.compareObjects(base[baseProperty], compare[baseProperty])) {
                            return false;
                        }
                        break;
                    // if one is function and other is not: return false
                    // if both are functions, compare function.toString() results
                    case 'function':
                        if (typeof compare[baseProperty] !== 'function' || base[baseProperty].toString() !== compare[baseProperty].toString()) {
                            return false;
                        }
                        break;
                    // otherwise, see if they are equal using coercive comparison
                    default:
                        // tslint:disable-next-line triple-equals
                        if (base[baseProperty] != compare[baseProperty]) {
                            return false;
                        }
                }
            }
            else {
                return false;
            }
        }
        // returns true only after false HAS NOT BEEN returned through all loops
        return true;
    };
    return CustomRouteReuseStrategy;
}());
export { CustomRouteReuseStrategy };
